import { Box, IconButton, Typography } from "@mui/material";
import PropTypes from "prop-types";

const REPORT_LINK_ICON_SRC = "/assets/images/report-link-icon.png";

const ReportLinkCell = ({ href, studentName = "", emptyText = "—" }) => {
  if (!href) {
    return (
      <Typography
        sx={{
          fontSize: 14,
          color: "#98A2B3",
          textAlign: "center",
          width: "100%",
        }}
      >
        {emptyText}
      </Typography>
    );
  }

  return (
    <IconButton
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Open latest report for ${studentName || "student"}`}
      onClick={(event) => event.stopPropagation()}
      sx={{
        color: "#1F4FB6",
        "&:hover": { bgcolor: "rgba(31, 79, 182, 0.08)" },
      }}
    >
      <Box
        component="img"
        src={REPORT_LINK_ICON_SRC}
        alt=""
        sx={{
          width: 16,
          height: 16,
          objectFit: "contain",
          display: "block",
        }}
      />
    </IconButton>
  );
};

ReportLinkCell.propTypes = {
  href: PropTypes.string,
  studentName: PropTypes.string,
  emptyText: PropTypes.string,
};

export default ReportLinkCell;
